var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group-item',{staticClass:"translate__item",attrs:{"href":'/#'+_vm.language.key},on:{"click":function($event){$event.preventDefault();return _vm.select.apply(null, arguments)}}},[_c('h2',{staticClass:"translate__text m-0"},[_vm._v(_vm._s(_vm.language.localisedName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }